import { ChatCircleText, Phone, WhatsappLogo } from "@phosphor-icons/react";
import { PHONE_NUMBER, PHONE_TEL, SMS_HREF, TEXT_NUMBER, WHATSAPP_HREF } from "@/components/ContactChannels";

const SISTER_SITES = [
  { label: "yellowthinking.com", href: "https://www.yellowthinking.com" },
  { label: "fasterbetter.ca", href: "https://www.fasterbetter.ca" },
  { label: "webcoders.ca", href: "https://www.webcoders.ca" },
];

/**
 * Shared footer used on every public page. Includes the legally-required
 * attribution, sister sites, and all three contact channels (call / SMS /
 * WhatsApp). SMS + WhatsApp route to the mobile number 1-416-805-5800.
 */
export default function Footer() {
  return (
    <footer className="border-t border-border bg-white">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-8 grid gap-6 md:grid-cols-3">
        <div data-testid="footer-attribution">
          <div className="label-overline mb-2">Auditor</div>
          <p className="text-xs text-ink-muted leading-relaxed">
            © 2026 Auditmysite.ca · Built for the performance of your site.
            A Division of Yellow Thinking.
          </p>
        </div>

        <div>
          <div className="label-overline mb-2">Sister sites</div>
          <ul className="space-y-1">
            {SISTER_SITES.map((s) => (
              <li key={s.href}>
                <a
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-site-${s.label.split(".")[0]}`}
                  className="text-xs text-ink hover:text-brand underline-offset-2 hover:underline transition-colors"
                >
                  {s.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="label-overline mb-2">Talk to a human</div>
          <a
            href={PHONE_TEL}
            data-testid="footer-phone-link"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-ink hover:text-brand transition-colors"
          >
            <Phone size={14} weight="fill" /> {PHONE_NUMBER}
          </a>
          <div className="mt-2 flex flex-wrap items-center gap-3 text-xs">
            <a
              href={SMS_HREF}
              data-testid="footer-sms-link"
              className="inline-flex items-center gap-1 text-ink-muted hover:text-ink underline-offset-2 hover:underline"
            >
              <ChatCircleText size={12} weight="fill" /> SMS
            </a>
            <a
              href={WHATSAPP_HREF}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="inline-flex items-center gap-1 text-ink-muted hover:text-ink underline-offset-2 hover:underline"
            >
              <WhatsappLogo size={12} weight="fill" /> WhatsApp
            </a>
            <span className="text-ink-muted">· {TEXT_NUMBER}</span>
          </div>
          <p className="text-xs text-ink-muted mt-2">Toronto, Canada · Mon–Fri</p>
        </div>
      </div>
    </footer>
  );
}
